import {ButtonTheme} from 'common/components/button/constants';
import {TagSize} from 'common/components/tag/types';
import {AxisUnitPrecision} from 'common/report/insights/util/types';

export interface SettingsLiParams {
  decimalPrecisionValue?: AxisUnitPrecision | null;
  decimalPrecisionUpdateFunc?: (val: AxisUnitPrecision | null) => void;
}

export interface SettingsLiAttrs {
  'all-tags'?: string[];
  button?: string;
  'button-icon'?: string;
  'button-theme'?: ButtonTheme;
  buttontext?: string;
  'custom-handling'?: boolean;
  'delete-button'?: boolean;
  disabled?: boolean;
  'disabled-message'?: string;
  editable?: boolean;
  editing?: boolean;
  emptiable?: boolean;
  fileaccept?: string;
  'fire-immediate-action'?: boolean;
  'hide-buttons'?: boolean;
  isfile?: boolean;
  label?: string;
  maxlength?: number;
  'multiline-input'?: boolean;
  placeholder?: string;
  'read-only-tags'?: string[];
  removable?: boolean;
  'selected-tags'?: string[];
  'tag-size'?: TagSize;
  tooltip?: string;
  info?: string;
  switchon?: boolean;
  type?: InputType;
  value?: string;
  'static-tags'?: boolean;
  'format-text'?: boolean;
  'text-area-rows'?: number;
  'text-area-resize'?: string;
}

export interface SettingsLiState {
  editing: boolean;
  password1: string;
  password2: string;
  countryCode: string;
  localPhoneNumber: string;
  type: InputType;
  isFile: boolean;
  allTags: Set<string>;
  readonlyTags: Set<string>;
  selectedTags: Set<string>;
  originalValue: string;
  originalSelectedTags: Set<string>;
  inputValue: string;
  saving: boolean;
  selectItems: any[];
  selectMenuOpen: boolean;
  selectTagOpen: boolean;
  selectedValue: any;
  uploading: boolean;
  saveDisabled: boolean;
  removable: boolean;
  validationError: string;
  stagedDecimalPrecision: AxisUnitPrecision | undefined | null;
  stagedAbbrev: boolean | null;
}

export enum InputType {
  Text = `text`,
  DecimalPrecision = `decimal-precision`,
  AbbrevToggle = `abbrev-toggle`,
  PhoneNumber = `phone-number`,
  MultiSelect = `multi-select`,
  Password = `password`,
  Tag = `tag`,
  Select = `select`,
  File = `file`,
  /** When type is set to "switch", this is a fully controlled component using the "switchon" attr. We may wish to add a
   * "switchupdating" attr and state, I just used "disabled" while it's updating */
  Switch = `switch`,
  Slot = `slot`,
  TextArea = `textarea`,
}
